"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calcTimeLabel = void 0;
const consts_1 = require("@opsbase/lib-time/consts");
function calcTimeLabel(mins) {
    let numWeeks = 0;
    let numDays = 0;
    let numHours = 0;
    let numMins = 0;
    let remaining = mins;
    if (remaining >= consts_1.WEEK_MINS) {
        numWeeks = Math.floor(remaining / consts_1.WEEK_MINS);
        remaining = remaining - numWeeks * consts_1.WEEK_MINS;
    }
    if (remaining >= consts_1.DAY_MINS) {
        numDays = Math.floor(remaining / consts_1.DAY_MINS);
        remaining = remaining - numDays * consts_1.DAY_MINS;
    }
    if (remaining >= consts_1.HOUR_MINS) {
        numHours = Math.floor(remaining / consts_1.HOUR_MINS);
        remaining = remaining - numHours * consts_1.HOUR_MINS;
    }
    numMins = remaining;
    return [
        !!numWeeks ? (numWeeks === 1 ? '1 week' : `${numWeeks} weeks`) : '',
        !!numDays ? (numDays === 1 ? '1 day' : `${numDays} days`) : '',
        !!numHours ? (numHours === 1 ? '1 hour' : `${numHours} hours`) : '',
        !!numMins ? (numMins === 1 ? '1 minute' : `${numMins} mins`) : '',
    ]
        .filter(v => !!v)
        .join(' ');
}
exports.calcTimeLabel = calcTimeLabel;
exports.default = calcTimeLabel;
